<template>
  <div @click="close" class="app_message">
    <div class="popb">
      <div class="box b_fff pt37 pb40 pl40 pr40 tac">
        <img src="@/assets/img/ok_h.png" alt="" class="all96">
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: '',
  props: {
    time:Number,
  },
  data () {
    return {
      
    }
  },
  mounted(){
      this.endTime();
  },
  methods:{
      endTime(){
        setTimeout(()=>{
          this.$emit('myevent', {close:true})
        }, this.time);
      },
      close(){
        this.$emit('myevent', {close:true})
      }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/message.vue